
import { Component, Vue, Prop } from 'vue-property-decorator'

import { formatErrorMessage as formatCsvValidationError } from './utils/errorFormatter'

interface ImportFail {
  row_number: number;
  errors: string[];
  row?: {
    firstname?: string;
    lastname?: string;
    email?: string;
    multi_choice_gift_card?: string;
    amount?: string;
    scheduled_at?: string;
    program?: string;
    [key: string]: string | undefined;
  };
}

@Component({
  name: 'ImportErrors'
})
export default class ImportErrors extends Vue {
  @Prop({ required: true }) readonly fails!: ImportFail[]

  private activeNames: string[] = ['errors']
  private currentPage = 1
  private readonly pageSize = 3

  get paginatedErrors(): ImportFail[] {
    const start = (this.currentPage - 1) * this.pageSize
    const end = this.currentPage * this.pageSize
    return this.fails.slice(start, end)
  }

  handleErrorPageChange(page: number): void {
    this.currentPage = page
  }

  copyErrorToClipboard(fail: ImportFail): void {
    let text = `${this.$t('common.line')} ${fail.row_number}:\n`

    if (fail.row) {
      if (fail.row.firstname || fail.row.lastname) {
        text += `${this.$t('gifts.uploadDialog.recipientInfo')}: ${fail.row.firstname} ${fail.row.lastname}\n`
      }
      if (fail.row.email) {
        text += `${this.$t('gifts.uploadDialog.emailInfo')}: ${fail.row.email}\n`
      }
    }

    text += fail.errors.join('\n')

    navigator.clipboard.writeText(text).then(() => {
      this.$notify({
        title: String(this.$t('components.copySuccess')),
        message: String(this.$t('gifts.uploadDialog.copySuccess')),
        type: 'success',
        duration: 2000
      })
    }).catch(() => {
      this.$notify({
        title: String(this.$t('components.copyError')),
        message: String(this.$t('gifts.uploadDialog.copyError')),
        type: 'error',
        duration: 2000
      })
    })
  }

  formatErrorMessage(error: string | Record<string, unknown>): string {
    return formatCsvValidationError(error, this.$t.bind(this), { includeLineNumber: false })
  }
}
